<ion-list>
  <ion-item  button (click)="openPage('/engagement')">
    <ion-icon slot="start" name="analytics"></ion-icon>
    <ion-label>Dashboard</ion-label>
  </ion-item>
  <ion-item  button (click)="openPage('/users/user/' + userId + '/details')">
    <ion-icon slot="start" name="person-outline"></ion-icon>
    <ion-label>Edit Profile</ion-label>
  </ion-item>
  <ion-item tappable (click)="logout()">
    <ion-icon slot="start" name="exit"></ion-icon>
    <ion-label>Logout</ion-label>
  </ion-item>
</ion-list>